import React, { createContext, useContext, useState, useCallback } from 'react';
import AuthPromptModal from '../components/common/AuthPromptModal';

interface AuthPromptContextType {
  openAuthPrompt: (targetPath?: string, featureName?: string) => void;
  closeAuthPrompt: () => void;
  isAuthPromptOpen: boolean;
}

const AuthPromptContext = createContext<AuthPromptContextType | undefined>(undefined);

export const AuthPromptProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [targetPath, setTargetPath] = useState('/');
  const [featureName, setFeatureName] = useState('Advanced Features');

  const openAuthPrompt = useCallback((path?: string, name?: string) => {
    if (path) setTargetPath(path);
    if (name) setFeatureName(name);
    setIsOpen(true);
  }, []);

  const closeAuthPrompt = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <AuthPromptContext.Provider value={{ openAuthPrompt, closeAuthPrompt, isAuthPromptOpen: isOpen }}>
      {children}
      <AuthPromptModal
        isOpen={isOpen}
        onClose={closeAuthPrompt}
        targetPath={targetPath}
        featureName={featureName}
      />
    </AuthPromptContext.Provider>
  );
};

export const useAuthPrompt = () => {
  const context = useContext(AuthPromptContext);
  if (!context) {
    throw new Error('useAuthPrompt must be used within an AuthPromptProvider');
  }
  return context;
};

export default AuthPromptContext;
